import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    backgroundColor: COLOR.LIGHT_GREEN,
    color: COLOR.WHITE,
    padding: [80, 0, 70],
    [MQ.TABLET]: {
      padding: [100, 0, 80],
    },
    [MQ.DESKTOP]: {
      padding: [134, 0, 110],
    },
  },
  yellow: {
    backgroundColor: COLOR.YELLOW,
    color: COLOR.DARK_GREEN,
  },
  container: {
    width: '75%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    [MQ.TABLET]: {
      width: '62%',
    },
    [MQ.TABLET_LARGE]: {
      width: '52%',
    },
    [MQ.DESKTOP]: {
      maxWidth: 718,
      width: '46%',
    },
  },
  title: {
    textAlign: 'center',
    [MQ.TABLET]: {
      width: '80%',
    },
    [MQ.TABLET_LARGE]: {
      width: '75%',
    },
    [MQ.DESKTOP]: {
      width: '70%',
    },
  },
  noBodyTitle: {
    marginBottom: 15,
    [MQ.DESKTOP]: {
      marginBottom: 25,
    },
  },
  body: {
    textAlign: 'center',
    margin: [15, 0, 25],

    [MQ.DESKTOP]: {
      margin: [15, 0, 40],
    },
    '& p': {
      margin: 0,
    },
  },
  buttonWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    maxWidth: 275,
    [MQ.DESKTOP]: {
      maxWidth: 450,
      gap: 25,
    },
  },
  buttonContainer: {
    margin: 'auto',
  },
})
